import { useQuery } from "@tanstack/react-query";
import type { StoreRoleView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

export function useStoreRolesQuery(storeSlug: string) {
  const query = useQuery({
    queryKey: queryKeys.seller.roles(storeSlug),
    queryFn: () => apiJsonClient<StoreRoleView[]>(endpoints.seller.roles),
    enabled: storeSlug.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
